import { Button, type ButtonProps } from './Button.tsx';
import Stack from '@mui/material/Stack';
import { ArrowIcon } from '../../assets/icons/arrow.tsx';

export const NextPageButton = (props: ButtonProps) => {
  const { sx, children, ...rest } = props;
  return (
    <Button fullWidth sx={{ alignItems: 'start', py: 10, ...sx }} {...rest}>
      <Stack width="100%" direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        {children}
        <ArrowIcon />
      </Stack>
    </Button>
  );
};